// extracted by mini-css-extract-plugin
module.exports = {"root":"H8pDn7wrkP78g65bcy97"};